import { render, staticRenderFns } from "./23.vue?vue&type=template&id=19aacc38&"
import script from "./23.vue?vue&type=script&lang=js&"
export * from "./23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports